import { setToString } from './set.utils.js';
import { iterToSet } from './transform.utils.js';
import { ROOT_CLASSNAMES } from '../constants/globals.js';

function getRootClassNames() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? null : _ref$theme,
      _ref$darkMode = _ref.darkMode,
      darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode,
      _ref$lightMode = _ref.lightMode,
      lightMode = _ref$lightMode === void 0 ? false : _ref$lightMode;

  var defaultClassNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var classNameSet = iterToSet(defaultClassNames);
  classNameSet.add(ROOT_CLASSNAMES.base);

  if (darkMode) {
    classNameSet.add(ROOT_CLASSNAMES.darkMode);
  }

  if (lightMode) {
    classNameSet.add(ROOT_CLASSNAMES.lightMode);
  }

  if (theme === 'holiday') {
    classNameSet.add(ROOT_CLASSNAMES.themeHoliday);
  }

  return setToString(classNameSet);
}

export { getRootClassNames };